import React, { useState, useEffect } from 'react';
import { Modal, Card, Empty, Grid, Spin } from 'antd';
import { BookOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/react-hooks';
import GET_HELP_CENTER_ARTICLES from '../../../../core/GraphQl/Queries/GET_HELP_CENTER_ARTICLES';
import { parseMarkdown } from '../../../ux/TagHelpCenter/MarkdownParser';
import { modal } from '../../../ux/Tasks/configs/designTokens';
import { resolveIcon } from './iconMap';
import './HelpCenterModal.scss';

const { useBreakpoint } = Grid;

const HelpCenterModal = ({ visible, onClose, feature, title, userActions = [] }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [selectedId, setSelectedId] = useState(null);

  const { data, loading } = useQuery(GET_HELP_CENTER_ARTICLES, {
    variables: { feature },
    skip: !visible,
  });

  const articles = data?.helpCenterArticles || [];

  const visibleArticles = articles.filter(
    (article) => !article.requiredAction || userActions.includes(article.requiredAction)
  );

  useEffect(() => {
    if (visibleArticles.length > 0 && !selectedId) {
      setSelectedId(visibleArticles[0].sectionId);
    }
  }, [visibleArticles, selectedId]);

  useEffect(() => {
    if (!visible) {
      setSelectedId(null);
    }
  }, [visible]);

  const activeArticle = visibleArticles.find((a) => a.sectionId === selectedId);
  const parsedContent = activeArticle ? parseMarkdown(activeArticle.content) : '';

  return (
    <Modal
      title={
        <span className="help-center-modal__title">
          <BookOutlined className="help-center-modal__title-icon" />
          {title || 'Help Center'}
        </span>
      }
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={modal.wide}
      centered
      className="help-center-modal"
      bodyStyle={{ padding: 0 }}
    >
      <div
        className={`help-center-modal__layout${isMobile ? ' help-center-modal__layout--mobile' : ''}`}
      >
        <div className="help-center-modal__sidebar">
          <ul className="help-center-modal__topics">
            {visibleArticles.map((article) => (
              <li
                key={article.sectionId}
                className={`help-center-modal__topic${selectedId === article.sectionId ? ' help-center-modal__topic--active' : ''}`}
                onClick={() => setSelectedId(article.sectionId)}
              >
                {resolveIcon(article.icon)}
                <span>{article.title}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="help-center-modal__content">
          {loading ? (
            <div className="help-center-modal__loading">
              <Spin size="large" tip="Loading help documentation..." />
            </div>
          ) : activeArticle ? (
            <Card
              title={
                <span>
                  {resolveIcon(activeArticle.icon)} {activeArticle.title}
                </span>
              }
              bordered={false}
              className="help-center-modal__card"
            >
              {parsedContent ? (
                <div
                  className="tag-help-content"
                  dangerouslySetInnerHTML={{ __html: parsedContent }}
                />
              ) : (
                <Empty description="No content available" />
              )}
            </Card>
          ) : (
            <Empty description="No documentation available for this feature" />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default HelpCenterModal;
